var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "39px",
    viewBox: "0 0 40 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FAAA8001-4772-43E5-AEFE-5D45E66402D3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BBFD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CDFE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Requirement-Popup---Enabled",
    transform: "translate(-400.000000, -521.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(208.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "In-Game-Achievement",
    transform: "translate(171.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "In-Game-Achievement-Icon",
    transform: "translate(21.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6459645,8.28235511 L35.5969167,15.3500802 C35.320766,17.2273996 33.6642228,18.7181803 31.7870838,18.7181803 L29.7991959,18.7181803 L30.7930497,7.12273882 L35.5415422,7.12273882 C35.9832751,7.12273882 36.2594257,7.28850136 36.3698138,7.45408352 C36.5355764,7.56465201 36.7011585,7.84062229 36.6459645,8.28235511 L36.6459645,8.28235511 Z M26.4309155,19.8226025 C26.1549453,22.9697459 23.5597424,25.3441726 20.3570442,25.3441726 L19.8049232,25.3441726 C16.6577798,25.3441726 14.0073829,22.9697459 13.7312322,19.8226025 L12.2956456,3.25771191 L27.8114884,3.25771191 L26.4309155,19.8226025 Z M4.56541147,15.3500802 L3.51618329,8.28235511 C3.46098923,7.84062229 3.6265714,7.56465201 3.79233394,7.45408352 C3.90272205,7.28850136 4.17887271,7.12273882 4.62060553,7.12273882 L9.36909807,7.12273882 L10.3631322,18.7181803 L8.37524432,18.7181803 C6.49792492,18.7181803 4.84138175,17.2273996 4.56541147,15.3500802 L4.56541147,15.3500802 Z M35.5415422,3.80983285 L31.06902,3.80983285 L31.2347825,1.60116874 C31.2899766,1.15943592 31.1243944,0.772897157 30.7930497,0.441732821 C30.461705,0.110388112 30.0199722,0 29.5782393,0 L10.4183263,0 C9.97659343,0 9.53486061,0.110388112 9.2035159,0.441732821 C8.87217119,0.772897157 8.70658902,1.27000441 8.76178308,1.71155685 L8.92736525,3.8650269 L4.45484299,3.8650269 C3.18501895,3.8650269 1.9702086,4.36195378 1.08674296,5.35580753 C0.258471374,6.34984166 -0.128067391,7.56465201 0.0376951499,8.83447604 L1.08674296,15.9022012 C1.58366984,19.3808697 4.67579958,22.0864607 8.20966215,22.0864607 L10.6942965,22.0864607 C11.7433443,25.3993666 14.6698919,27.884001 18.2589485,28.3809279 L18.2589485,35.2830709 L12.5716159,35.2830709 C11.6329562,35.2830709 10.9152531,36.000774 10.9152531,36.9394337 C10.9152531,37.8782737 11.6329562,38.5959768 12.5716159,38.5959768 L27.2591871,38.5959768 C28.1978468,38.5959768 28.9157303,37.8782737 28.9157303,36.9394337 C28.9157303,36.000774 28.1978468,35.2830709 27.2591871,35.2830709 L21.7376171,35.2830709 L21.7376171,28.3259142 C25.3266737,27.8289873 28.1978468,25.3441726 29.3020887,22.0310862 L31.7869034,22.0310862 C35.3205856,22.0310862 38.3575213,19.3256756 38.9098226,15.8470071 L39.9588704,8.77928199 C40.1244526,7.50927758 39.7931079,6.29446723 38.9098226,5.30079385 C38.081551,4.30675972 36.8669211,3.80983285 35.5415422,3.80983285 L35.5415422,3.80983285 Z",
    id: "Fill-1-Copy-6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementIcon);
export default __webpack_public_path__ + "static/media/achievement-icon.51deb8f82a5f30833223393a7e94d466.svg";
export { ForwardRef as ReactComponent };